export default "__VITE_ASSET__Dgm0oVRC__"